module.exports = __webpack_public_path__ + "img/cutaway_stopped.7d3351ee.svg";